namespace TabAurous.Sales {
    export namespace DeliveryChallanPostingService {
        export const baseUrl = 'Sales/DeliveryChallanPosting';

        export declare function List(request: TransactionRequest, onSuccess?: (response: Serenity.ListResponse<Common.MasterTransaction>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;

        export declare const enum Methods {
            List = "Sales/DeliveryChallanPosting/List"
        }

        [
            'List'
        ].forEach(x => {
            (<any>DeliveryChallanPostingService)[x] = function (r, s, o) {
                return Q.serviceRequest(baseUrl + '/' + x, r, s, o);
            };
        });
    }
}
